import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

export const Container = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    width: 0.275rem;
`;

export const Line = styled.div`
    ${({ theme }) => css`
        height: 100%;
        width: 100%;
        background: ${theme.colors.secondary.tints[1].hex};
    `}
`;

export const AnimatedLine = styled(animated.div)`
    ${({ theme }) => css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background: ${theme.colors.campaigns.clearing.primary.hex};
    `}
`;

export const Circle = styled.div<{ $active: boolean }>`
    ${({ theme, $active }) => css`
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 1rem;
        width: 1rem;
        border: 0.25rem solid ${theme.colors.secondary.tints[1].hex};
        border-radius: 50%;
        background: ${theme.colors.primaryContrast.hex};

        ${$active &&
        css`
            border-color: ${theme.colors.campaigns.clearing.primary.hex};
        `}
    `}
`;

export const ContainerMobile = styled(Container)`
    ${({ theme }) => css`
        position: relative;
        top: 0;
        left: auto;
        height: 4rem;
        width: 0.175rem;

        &&&& {
            margin: 1.5rem auto;
        }

        @media ${theme.breakpoints.large.media} {
            display: none;
        }
    `}
`;

export const CircleMobile = styled(Circle)`
    top: 50%;
    border-width: 0.175rem;
`;
